import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hourRangePipe',
  standalone: true
})
export class HourRangePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';

    const parts = value.split('T');
    if (parts.length < 2) return '';

    const [hh] = parts[1].split(':').map(Number);
    const h = String(hh).padStart(2, '0');

    return `De ${h}:00 a ${h}:59`; //de 1:00 a 2:00
  }
}
